<template>
  <div class="lv-checkbox-file">
    <ValidationProvider v-slot="{ errors }" :rules="rules">
      <label for="checkbox">
        <input id="checkbox" v-model="checked" type="checkbox" />
        <span class="lv-checkbox-file__icon">
          <i class="checked icon-check-box" />
          <i class="unchecked icon-check-box-outline-blank" />
        </span>
        <LvText h6>{{ checkbox.text }}</LvText>
        <LvText h6 blue @click="$_onOpenPreviewPopup($event, num)"
          >「{{ checkbox.fileName }}」</LvText
        >
      </label>
      <div v-if="errors.length > 0" class="invalid-text">
        <i class="icon-warning invalid-icon" />
        <p v-for="(text_e, text_k) in errors" :key="text_k" class="text">
          {{ $t(text_e) }}
        </p>
      </div>
    </ValidationProvider>
    <PreviewPopUp
      download
      :num="num"
      :ref="'popup' + num"
      :textLabel="_textLabel"
      :popUpActive="isActive.previewPopup"
      @click="$_onClosePreviewPopup()"
    />
    <PopUp
      notice
      :popUpActive="isActive.noFile"
      :title="`${$t('沒有')}「${$t('簽約前提醒事項列表')}」`"
      @click="isActive.noFile = false"
    >
      <LlCancelPopupContent>
        <template v-slot:buttons>
          <WsButton001 @click="isActive.noFile = false">
            {{ $t('知道了') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
    </PopUp>
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: '此項目為必填',
});
extend('required_true_value', value => {
  if (value) {
    return true;
  }
  return '此項目為必填';
});
export default {
  components: {
    ValidationProvider,
  },
  props: {
    checkbox: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    num: {
      type: Number,
      default: 0,
    },
    rules: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    isActive: {
      previewPopup: false,
      noFile: false,
    },
    checked: false,
  }),

  computed: {
    _textLabel() {
      return this.checkbox.file;
    },
  },

  methods: {
    $_onClosePreviewPopup() {
      this.$emit('click');
      this.isActive.previewPopup = false;
    },
    $_onOpenPreviewPopup() {
      this.$emit('click');
      if (!this.checkbox.file) {
        this.isActive.noFile = true;
        return;
      }
      this.isActive.previewPopup = true;
    },
  },
};
</script>
